import { RECEIVE_USERS, UPDATE_USER, ADD_USER, DELETE_USER } from '../actions/users'

export default function enquiries (state = {}, action) {
	const { user } = action

	switch (action.type) {
		case RECEIVE_USERS :
			return action.users === null
				? {}
				: {
					...state,
					...action.users
				}

		case UPDATE_USER :
			return {
        ...state,
        [user.id]: user
			}
			break

		case ADD_USER :
			return {
        ...state,
        [action.user.id]: action.user
			}

		case DELETE_USER :
			const newState = Object.values(state).filter((user) => user.id !== action.userId)
				.reduce((obj, item) => {
			     obj[item.id] = item
			     return obj
			   }, {})

			return newState

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/users.js